import { getStack } from '@/lib/contentstack/stack';
const locale = process.env.NEXT_PUBLIC_APP_LOCALE;

export async function getPriorityArticles() {
  const allPriorityArticles = [];
  const batchSize = 100; // Fetch articles in batches
  let skip = 0;

  try {
    while (true) {
      // Initialize the query to fetch priority articles with dimensions included
      const Stack = getStack();
      const query = Stack.ContentType('article')
        .Query()
        .addParam('include_dimension', 'true')
        .includeReference('category')
        .query({
          locale: locale,
          tags: { $in: ['priority'] }
        })
        .skip(skip)
        .limit(batchSize)
        .toJSON();

      // Fetch the current batch of priority articles
      const response = await query.find();
      const currentBatch = response[0] || [];

      // Append current batch to allPriorityArticles
      allPriorityArticles.push(
        ...currentBatch.map((article) => ({
          title: article.title,
          url: article.url,
          categoryConnection: article.category
            ? {
                title: article.category[0].title,
                url: article.category[0].url
              }
            : null,
          date: article.date,
          feature_image: article.feature_image,
          json_rte: article.json_rte
        }))
      );

      // Break the loop if fewer articles are returned than the batch size
      if (currentBatch.length < batchSize) break;

      // Increment skip to fetch the next batch
      skip += batchSize;
    }

    return allPriorityArticles;
  } catch (error) {
    console.error('Error fetching priority articles:', error);
    throw error;
  }
}
